import { render } from "./ZTruckInv.vue?vue&type=template&id=c18f4f22"
import script from "./ZTruckInv.vue?vue&type=script&lang=js"
export * from "./ZTruckInv.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__